import React, { useEffect, useRef, useState } from "react";
import { success, vector } from "../../assets/img";
import { useLocation } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import moment from "moment";
import DownloadNumberPdf from "../../Component/DownloadNumberPdf";
import { Margin, usePDF } from 'react-to-pdf';
import { Toast } from "../../Component/Toast";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import CustomScroll from "../../Component/CustomScroll";
import { MaskIcon } from "../../Component/MaskIcon";
import { PRIMARY_COLOR, PRIMARY_COLOR_RGB } from "../../Services/Colors";

const NumberWise = () => {
  const location = useLocation();
  const listData = location.state?.listData;
  const slotId = location.state?.slotId;
  const [downSuccess, setDownSuccess] = useState(false);
  const [loading, setLoading] = useState(false);


  const ID = location.state?.ID;
  const reportName = location.state?.reportName;
  const lot_name = location.state?.lot_name;
  const time = location.state?.time;
  const date = location.state?.date;

  const { toPDF, targetRef } = usePDF({
    filename: `${`Garudanumberwisereport_${date}_${time}`}.pdf`,
    page: { margin: Margin.MEDIUM, orientation: 'portrait' },
  });

  const [list, setList] = useState(listData || []);


  const fetchList = async () => {
    // setLoader(true);
    const res = await get(`${URLS.SALESREPORT}/${reportName}?${ID}`);

    //     console.log("Sales Report Response:", res);
    if (res?.status === "success") {
      setList(res || []);
    }
    // setLoader(false);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("pageReloaded", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  useEffect(() => {
    const wasReloaded = sessionStorage.getItem("pageReloaded");

    if (wasReloaded === "true") {
      fetchList();
      sessionStorage.removeItem("pageReloaded"); // important
    }
  }, []);


  const generatePdf = ({
    title = "Number Wise-Report",
    slot, // { date, lot_name, time }
    rows = [],
  }) => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    /* ================= HEADER ================= */

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.text(`Garuda Agency – ${title}`, pageWidth / 2, 15, {
      align: "center",
    });

    // Slot meta
    if (slot) {
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text(
        `Date: ${moment(slot.date).format("DD-MM-YYYY")}  |  Lot: ${slot.lot_name}  |  Time: ${slot.time}`,
        pageWidth / 2,
        22,
        { align: "center" }
      );
    }

    // Generated time
    doc.text(
      `Report Generated on: ${moment().format("DD-MM-YYYY hh:mm a")}`,
      pageWidth / 2,
      28,
      { align: "center" }
    );

    // Divider
    doc.setLineWidth(0.6);
    doc.line(10, 32, pageWidth - 10, 32);

    /* ================= TABLE DATA ================= */

    const tableBody =
      rows.length > 0
        ? rows.map((r) => {
          const isTotal =
            typeof r.details === "string" &&
            r.details.toLowerCase().includes("total");

          if (isTotal) {
            return {
              isTotal: true,
              row: [
                {
                  content: r.details,
                  colSpan: 2,
                  styles: {
                    halign: "right",
                    fontStyle: "bold",
                    color:"white"
                  },
                },
                {
                  content: r.number,
                  styles: {
                    fontStyle: "bold",
                  },
                },
              ],
            };
          }

          return {
            isTotal: false,
            row: [r.date, r.details, r.number],
          };
        })
        : [];


    const tableWidth = 120; // total of column widths

    /* ================= TABLE ================= */

    autoTable(doc, {
      startY: 36,
      head: [["Date", "Details", "Number"]],

      body: tableBody.length
        ? tableBody.map((t) => t.row)
        : [[{ content: "No Data", colSpan: 3, styles: { halign: "center" } }]],

      foot: [[
        {
          content: "Total Quantity",
          colSpan: 2,
          styles: { halign: "right" }
        },
        {
          content: list?.overallcount || "0",
          content: `${list?.overallcount ?? 0}`,
          colSpan: 0,
          styles: { halign: "left" }
        }
      ]],

      showFoot: "lastPage",

      styles: {
        fontSize: 10,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineWidth: 0.1,
        lineColor: [200, 200, 200],
        valign: "middle",
        halign: "center",
        fontStyle: "bold",
      },

      headStyles: {
        fillColor: PRIMARY_COLOR_RGB,
        textColor:  [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 11,
      },

      footStyles: {
        fontSize: 12,
        fontStyle: "bold",
        halign: "left",
        fillColor: [198, 239, 206]

      },

      columnStyles: {
        0: { cellWidth: 30 },
        1: { cellWidth: 60 },
        2: { cellWidth: 30 },
      },

      didParseCell(data) {
        const rowIndex = data.row.index;
        const isTotal = tableBody[rowIndex]?.isTotal;

        if (isTotal && data.section === "body") {
          data.cell.styles.fillColor =[220, 169, 185];
          data.cell.styles.textColor = PRIMARY_COLOR_RGB; 
        }
      },

      margin: {
        left: (pageWidth - tableWidth) / 2,
        top: 5,
        bottom: 10,
      },
    });

    /* ================= SAVE ================= */

    const fileDate = slot?.date
      ? moment(slot.date).format("DD-MM-YYYY")
      : moment().format("DD-MM-YYYY");

    const fileTime = slot?.time || "NA";

    doc.save(`Garudanumberwisereport_${fileDate}_${fileTime}.pdf`);
  };


  const handleDownload = async () => {
    if (!list?.data?.length) {
      Toast("No data available to download");
      return;
    }

    const slot = {
      date: date,
      lot_name: lot_name,
      time: time || "N/A",
    };

    try {
      setLoading(true);

      // ✅ correct way to call generatePdf
      generatePdf({
        title: "Number Wise Report",
        slot: slot,
        rows: list.data,
      });

      setDownSuccess(true);
    } catch (error) {
      console.error(error);
      Toast("Failed to download PDF");
    } finally {
      setLoading(false);
    }
  };



  const [browsHeader, setBrowsHeader] = useState(false);
  const maxViewportHeight = useRef(0);

  useEffect(() => {
    const detectBrowserHeader = () => {
      const vh =
        window.visualViewport?.height || window.innerHeight;

      // store the maximum height (header hidden state)
      if (vh > maxViewportHeight.current) {
        maxViewportHeight.current = vh;
      }

      // if current height is smaller → header is visible
      const isHeaderVisible = vh < maxViewportHeight.current;

      setBrowsHeader(isHeaderVisible);
      // debug
      //       console.log({
      //         currentHeight: vh,
      //         maxHeight: maxViewportHeight.current,
      //         browsHeader: isHeaderVisible,
      //       });
    };

    detectBrowserHeader();

    window.visualViewport?.addEventListener("resize", detectBrowserHeader);
    window.addEventListener("resize", detectBrowserHeader);

    return () => {
      window.visualViewport?.removeEventListener("resize", detectBrowserHeader);
      window.removeEventListener("resize", detectBrowserHeader);
    };
  }, [browsHeader]);





  return (
    <div className="dashRightView marginScrolls" style={{
      display: "flex", flexDirection: "column",
      width: '100%',
      // marginBottom: browsHeader ? 75 : 42,
      // paddingBottom: browsHeader ? 94 : 45
    }}>
      <CustomScroll height="100vh">
        <div style={{
          // overflow: 'scroll'
        }} className="container_overalls">

          {/* Download Button */}
          <div style={{ margin: 20, marginRight: 42 }} className="d-flex ac-je">
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                style={{ color: PRIMARY_COLOR, width: 12, height: 12 }}
              />
            ) : downSuccess ? (
              <img src={success} height={20} />
            ) : (
              <MaskIcon onClick={handleDownload} src={vector} height={15} />
            )}
          </div>

          {/* Table */}
          <div className="tablealign hide-horizontal-scroll" style={{ overflowX: "scroll", margin: 15, marginBottom: 40, marginTop: 30, width: '93%' }}>
            <table
              border="1"
              className="table-border"
              style={{
                borderCollapse: "collapse",
                // width: "100%",
                textAlign: "left",
                // minWidth: "600px",
                marginBottom: list?.data?.length === 0 ? 0 : 70,
              }}
            >
              <thead>
                <tr>
                  <th style={{ color: PRIMARY_COLOR, fontFamily: 'f3', fontSize: 14, textAlign: "center" }}>Date</th>
                  <th style={{ color: PRIMARY_COLOR, fontFamily: 'f3', fontSize: 14, textAlign: "center" }}>Time</th>
                  <th style={{ color: PRIMARY_COLOR, fontFamily: 'f3', fontSize: 14, textAlign: "center" }}>Lot</th>
                  <th style={{ color: PRIMARY_COLOR, fontFamily: 'f3', fontSize: 14, textAlign: "center" }}>Details</th>
                  <th style={{ color: PRIMARY_COLOR, fontFamily: 'f3', fontSize: 14, textAlign: "center" }}>Number</th>
                </tr>
              </thead>

              <tbody>

                {list?.data?.map((r, index) => {
                  const isTotal = r.details?.toLowerCase().includes("total");

                  return (
                    <tr key={index} className={isTotal ? "total-row" : ""}>

                      {/* ✅ Merge Date + Time + Lot for TOTAL rows */}
                      {isTotal ? (
                        <td colSpan={3}></td>
                      ) : (
                        <>
                          <td
                            style={{
                              width: 75,
                              minWidth: 80,
                              paddingLeft: 5,
                              color: "rgb(0,0,0)",
                              fontFamily: "f2",
                              fontSize: 12,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {r.date}
                          </td>

                          <td
                            style={{
                              width: 20,
                              paddingLeft: 5,
                              color: "rgb(0,0,0)",
                              fontFamily: "f2",
                              fontSize: 12,
                            }}
                          >
                            {r.time}
                          </td>

                          <td
                            style={{
                              width: 20,
                              paddingLeft: 5,
                              color: "rgb(0,0,0)",
                              fontFamily: "f2",
                              fontSize: 12,
                            }}
                          >
                            {r.lot === "Kerala" ? "Kerala" : "Dear"}
                          </td>
                        </>
                      )}

                      {/* DETAILS COLUMN */}
                      <td
                        style={{
                          width: 165,
                          minWidth: 170,
                          paddingLeft: 5,
                          color: isTotal ? "white" : "rgb(0,0,0)",
                          fontFamily: "f2",
                          fontSize: 12,
                        }}
                      >
                        {r.details}
                      </td>

                      {/* NUMBER COLUMN */}
                      <td
                        style={{
                          minWidth: 88,
                          paddingLeft: 5,
                          color: isTotal ? "white" : "rgb(0,0,0)",
                          fontFamily: "f2",
                          fontSize: 12,
                          fontWeight: isTotal ? "bold" : "normal",
                        }}
                      >
                        {r.number}
                      </td>
                    </tr>
                  );
                })}


              </tbody>
            </table>
            {(list?.data?.length === 0) ? (
              <div style={{
                width: '100%', display: 'flex',
                justifyContent: 'center'
              }}>
                <span style={{ fontSize: 15, fontFamily: 'f3' }}>No Data</span>
              </div>
            ) : null}
          </div>


        </div >


      </CustomScroll>
      {/* Total Quantity Section */}
      <div className="d-flex ac-jb px-3 team_size">
        <p className="f3 fs-sm-14 white">Total Quantity</p>
        <p className="f3 fs-sm-14 white">{list?.overallcount || 0}</p>
      </div>
    </div>
  );
};

export default NumberWise;
